// tslint:disable:no-any
import * as React from 'react';
import styled from 'styled-components';
import List from 'antd/lib/list';
import Avatar from 'antd/lib/avatar';

import logo from './images/logo.png';
import img_hero_bg from './images/bg.jpg';

const Wrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  height: 100vh;
  background-image: url(${img_hero_bg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const Info = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  min-width: 40%;
  padding: 30px;
  text-align: center;
`;

const ContactInfo = styled.div`
  margin-top: 30px;
  text-align: left;
`;

class App extends React.Component {
  render() {
    const addressInfo: any = [
      { icon: 'phone', title: 'Call 473-443-1064' },
      { icon: 'mail', title: 'food@laurasgrenada.com' },
      { icon: 'instagram', title: 'https://www.instagram.com/lauras_at_grenada_marine/' },
      {
        icon: 'facebook',
        title: 'https://www.facebook.com/laurasatgrenadamarine'
      }
    ];
    return (
      <div className="page">
        <Wrapper>
          <Info>
            <img src={logo} alt="" />
            <ContactInfo>
              <List
                itemLayout="horizontal"
                split={false}
                dataSource={addressInfo}
                renderItem={(item: any) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={
                        <Avatar
                          icon={item.icon}
                          style={{ backgroundColor: 'rgba(65,68,26,1)' }}
                        />
                      }
                      title={item.title}
                    />
                  </List.Item>
                )}
              />
            </ContactInfo>
          </Info>
        </Wrapper>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx